import { Component, ElementRef, ViewChild, OnInit, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { CoopServiceService } from '../../../services/Coop/coop-service.service';
import { ViewerService } from '../../../services/Viewer/viewer.service';
import { AuthenService } from '../../../services/Authen/authen.service'
import { registerLocaleData } from '@angular/common';
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser } from '@angular/common';
import { Router } from "@angular/router";
import { FamerServiceService } from "src/app/services/Fammer/famer-service.service";
import he from '@angular/common/locales/he';
declare var google: any;

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { callable, session_year } from "src/app/components/callable";

@Component({
  selector: 'app-agri-profile',
  templateUrl: './agri-profile.component.html',
  styleUrls: ['./agri-profile.component.scss']
})
export class AgriProfileComponent implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId, private zone: NgZone,
    private router: Router,
    private CoopServiceService: CoopServiceService,
    private SpinnerService: NgxSpinnerService,
    private ViewerService: ViewerService,
    private AuthenService: AuthenService,
    private FamerServiceService: FamerServiceService,
  ) { }

  @ViewChild('MemberChart') MemberChart: ElementRef;
  @ViewChild('Coop_regions') Coop_regions: ElementRef;

  coopId: any;
  ProfileInfo: any;
  CoopMemberItemYearByCoopId: any;
  year_now: any;
  datayear: any;
  SumCommittee: any;
  dataSetMember: any;
  CommitteeItemYearByCoopId: any;
  CpdRiceYear: any;
  CpdRubberYear: any;
  CpdOaeYear: any;
  rice: any;
  rubber: any;
  cpd: any;
  AssetYear: any;
  asset: any;
  machine: any;
  product: any;
  business: any;
  MachinesByRegister: any;
  CollectYear: any;
  CoopBusinessLastest: any;
  StatusProvinceYearOne_chart: any;
  statusSector: any;
  check_Length_0: any;
  check_Length_1: any;
  check_Length_2: any;
  check_Length_3: any;
  check_Length_4: any;
  check_Length_5: any;
  check_Length_6: any;
  CoopDefect: any
  check_Id: any
  check_Data: any
  check_Data1: any
  check_Data2: any
  check_Data3: any
  check_Data4: any
  check_Data5: any
  check_Data6: any
  netAssets_year_now: any = 0
  liabilities_year_now: any = 0
  coopCapital_year_now: any = 0
  netProfit_year_now: any = 0
  FinanceFiveYears: any
  ViewRiceOracleSumYear: any
  ViewOaeOracleSumYear: any
  ViewRubberOracleSumYear: any
  memberBusinessShow = true
  memDepositShow = true
  memCreditShow = true
  memSaleShow = true
  memGoodShow = true
  memMarketingShow = true
  memServiceShow = true
  memOtherShow = true
  datayear_Lst;
  Date_now;
  year_now_;
  Date_after_day;
  Month_now;
  year_FinanceFive: any;
  year_Pratic: any;
  year_Pratic_Other: any;
  year_Pratic_Service: any;
  year_Pratic_Mageting: any;
  year_Pratic_Good: any;
  year_Pratic_Sale: any;
  year_Pratic_Credit: any;
  year_Pratic_Deposit: any;
  depositVal1Show = true;
  creditVal1Show = true;
  saleVal1Show = true;
  collectVal1Show = true;
  transformVal1Show = true;
  serviceVal1Show = true;

  check_Length_g1: any = true;
  check_Length_g2: any = true;
  check_Length_g3: any = true;
  check_Length_g4: any = true;

  tmp_: any;
  viewer: any;
  auth_data: any;
  defect_on = false;
  shortComings_verify = false;
  coop_verify = false;
  balance_sheet_verify = false;
  OrgOrgId: any;
  defect_verify = false;
  monthNamesThai = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
    "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤษจิกายน", "ธันวาคม"];

  yearData = callable.checkYearNow();
  listYear = callable.listYear();
  listsector = callable.getMasterSector();
  sector_now = callable.getCurrentSector();

  ngOnInit(): void {
    this.SpinnerService.show();
    // this.verify_role();
    this.coopId = sessionStorage.getItem('coopId');
    this.year_now = ((new Date()).getFullYear() - 1) + 543;
    this.year_now_ = ((new Date()).getFullYear()) + 543;
    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now + 1;
    this.cpd = true;
    this.asset = true;
    this.product = true;

    if (this.coopId == undefined) {
      this.router.navigate(["/"]);
    }
    else if (this.coopId != undefined) {
      this.get_auth_verify();
      this.get_viewer();
      this.GetLastestProfile();
      // this.GetCoopDefect();
      this.viewgraph();

      this.GetMachinesByRegister();
      this.GetAssetYear();
      // this.GetCoopViewOaeOracleSumYear();
      // this.GetCoopViewRubberOracleSumYear();
      this.GetCollectYear();
      this.GetFinanceFiveYears();
    }

    registerLocaleData(he);
  }

  async selectNewYearAndSector(year, sector) {
    this.SpinnerService.show();
    if (year) {
      this.year_now = callable.getCurrentYear(year);
    }

    if (sector) {
      this.sector_now = callable.getCurrentSector(sector);
    }

    this.get_date_now_and_after();
    this.datayear = this.year_now;
    this.datayear_Lst = this.year_now_;

    sessionStorage.setItem(session_year, this.year_now);
    this.yearData = callable.checkYearNow();

    this.GetLastestProfile();
    this.GetMachinesByRegister();
    this.GetAssetYear();
    this.GetCollectYear();
    this.GetFinanceFiveYears();

    registerLocaleData(he);

    setTimeout(() => {
      this.viewgraph();
    }, 500);

    setTimeout(() => {
      this.SpinnerService.hide();
      // sessionStorage.removeItem(session_year);
    }, 1000);
  }

  verify_role() {
    let user = JSON.parse(localStorage.getItem("access_token"));
    if (user && user['role'] == 'Admin') {
      this.router.navigate(["/user-management"]);
    }
  }

  get_date_now_and_after() {
    let Date_today = new Date();
    this.Date_after_day = new Date(Date_today);
    this.Date_after_day.setDate(this.Date_after_day.getDate() - 1);
    this.Month_now = this.monthNamesThai[(this.Date_after_day.getMonth() + 1)];
    this.monthNamesThai[this.Month_now]
    this.Date_now = Date_today.getDate()
    this.Date_after_day = this.Date_after_day.getDate()
  }

  get_auth_verify() {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    if (this.auth_data != null) {
      this.AuthenService.Get_manage_role(this.auth_data['role']).subscribe(
        responce => {
          if (this.auth_data['role'] == 'Admin') {
            this.coop_verify = true;
            this.balance_sheet_verify = true;
            this.defect_on = true;
            this.defect_verify = true;
          } else {
            this.AuthenService.GetProvinceByUserid(this.auth_data['user_id']).subscribe(
              res => {
                for (let i = 0; i < responce.length; i++) {
                  if (responce[i]['menu'] == 'ข้อบกพร่อง' && responce[i]['status'] == 'y') {
                    this.defect_on = true;

                  }
                  if ((responce[i]['menu'] == 'จำนวนสหกรณ์' && responce[i]['status'] == 'y')) {
                    this.coop_verify = true;
                  }
                  if (responce[i]['menu'] == 'งบดุล' && responce[i]['status'] == 'y') {
                    this.balance_sheet_verify = true;
                  }
                }

                if (this.auth_data['role'] == 'Executive' || this.auth_data['role'] == 'Central_agency') {
                  this.defect_verify = true;

                } else {
                  this.CoopServiceService.GetProvinceByCoopId(this.coopId).subscribe(
                    response => {
                      this.OrgOrgId = response[0]['orgOrgId'].trim();
                      for (let j = 0; j < res.length; j++) {
                        if (res[j]['orgOrgId'].trim() == this.OrgOrgId) {
                          this.defect_verify = true;
                          break;
                        }
                      }
                    }
                  );
                }
              }
            );
          }
        }
      );
    }
  }

  get_viewer() {
    let count;
    this.ViewerService.Get_viewer_Coop(this.coopId).subscribe(responce => {
      if (responce.length > 0) {
        this.viewer = responce[0].count + 1;
        count = parseInt(this.viewer);
        this.viewer = this.viewer.toLocaleString();
        this.ViewerService.Update_viewerCount_Coop(this.coopId).subscribe(
          responce => {
          }
        )
      } else {
        this.viewer = 1;
        this.ViewerService.create_viewer_Coop(this.coopId).subscribe(
          responce => {
          }
        )
      }
    });
  }

  GetLastestProfile() {
    this.SpinnerService.show();

    this.FamerServiceService.GetLastestProfileAGRI(this.coopId).subscribe(res => {
      this.ProfileInfo = res;
      for (let i = 0; i < res.length; i++) {
        this.statusSector = res[i].statusSector;

        this.SumCommittee = res[i].committeeM + res[i].committeeFm;
      }

    });
    this.SpinnerService.hide();

  }

  GetMachinesByRegister() {
    this.FamerServiceService.GetAgriMachineByCoopId(this.coopId).subscribe(res => {
      this.MachinesByRegister = res;
      if (res.length == 0) {
        this.check_Length_4 = true;
      } else {
        this.check_Length_4 = false;

      }
    })
  }

  GetAssetYear() {
    this.FamerServiceService.GetAgriAssetByCoopId(this.coopId).subscribe(res => {
      this.AssetYear = res;
      if (res.length == 0) {
        this.check_Length_3 = true;
      } else {
        this.check_Length_3 = false;

      }
    })
  }

  GetCollectYear() {
    this.FamerServiceService.GetAgriCollectYear(this.coopId).subscribe(res => {
      this.CollectYear = res;
      if (res.length == 0) {
        this.check_Length_5 = true;
      } else {
        this.check_Length_5 = false;

      }
    })
  }

  GetFinanceFiveYears() {
    this.FamerServiceService.GetAgriFinanceFiveYears(this.coopId).subscribe(res => {
      this.FinanceFiveYears = res;
      for (let i = 0; i < res.length; i++) {
        if (res[res.length - 1].dataYear) {
          this.year_FinanceFive = res[res.length - 1].dataYear;
          if (res[i].netAssets) {
            this.netAssets_year_now = res[i].netAssets;
          }
          if (res[i].liabilities) {
            this.liabilities_year_now = res[i].liabilities;
          }
          if (res[i].coopCapital) {
            this.coopCapital_year_now = res[i].coopCapital;
          }
          if (res[i].netProfit) {
            this.netProfit_year_now = res[i].netProfit;
          }
        }
      }

    })
  }

  viewgraph() {

    this.FamerServiceService.GetAgriFinanceFiveYears(this.coopId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // สามเหลี่ยม
      // สินทรัพย์ของสหกรณ์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        // Themes end

        let chart = am4core.create("chartdiv", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        let data = [];
        let net = "หน่วย : ล้านบาท"
        for (let i = 0; i < res.length; i++) {
          if (res[i].netAssets) {
            data.push({
              "year": res[i].dataYear,
              "value": res[i].netAssets
            })
          }
        }

        chart.data = data;

        chart.logo.disabled = true;

        // Export
        chart.exporting.menu = new am4core.ExportMenu();

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        // valueAxis.min = 0;

        let series = chart.series.push(new am4charts.CurvedColumnSeries());
        series.dataFields.categoryX = "year";
        series.dataFields.valueY = "value";
        series.tooltipText = "{valueY.value}"
        series.columns.template.strokeOpacity = 0;
        series.columns.template.fillOpacity = 0.75;

        let hoverState = series.columns.template.states.create("hover");
        hoverState.properties.fillOpacity = 1;
        hoverState.properties.tension = 0.4;

        chart.cursor = new am4charts.XYCursor();

        // Add distinctive colors for each column using adapter
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
      })

      // หนี้สินของสหกรณ์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        // Themes end
        let chart = am4core.create("chartdiv2", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        let data = [];
        let net = "หน่วย : ล้านบาท"

        for (let i = 0; i < res.length; i++) {
          if (res[i].liabilities) {
            data.push({
              "year": res[i].dataYear,
              "value": res[i].liabilities
            })
          }
        }

        chart.data = data;

        chart.logo.disabled = true;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        // valueAxis.min = 0;

        let series = chart.series.push(new am4charts.CurvedColumnSeries());
        series.dataFields.categoryX = "year";
        series.dataFields.valueY = "value";
        series.tooltipText = "{valueY.value}"
        series.columns.template.strokeOpacity = 0;


        series.columns.template.fillOpacity = 0.75;

        let hoverState = series.columns.template.states.create("hover");
        hoverState.properties.fillOpacity = 1;
        hoverState.properties.tension = 0.4;

        chart.cursor = new am4charts.XYCursor();

        // Add distinctive colors for each column using adapter
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
      })

      // ทุนของสหกรณ์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        // Themes end

        let chart = am4core.create("chartdiv3", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        let data = [];
        let net = "หน่วย : ล้านบาท"
        for (let i = 0; i < res.length; i++) {
          if (res[i].coopCapital) {
            data.push({
              "year": res[i].dataYear,
              "value": res[i].coopCapital
            })
          }
        }

        chart.data = data;

        chart.logo.disabled = true;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        // valueAxis.min = 0;
        let series = chart.series.push(new am4charts.CurvedColumnSeries());
        series.dataFields.categoryX = "year";
        series.dataFields.valueY = "value";
        series.tooltipText = "{valueY.value}"
        series.columns.template.strokeOpacity = 0;


        series.columns.template.fillOpacity = 0.75;

        let hoverState = series.columns.template.states.create("hover");
        hoverState.properties.fillOpacity = 1;
        hoverState.properties.tension = 0.4;

        chart.cursor = new am4charts.XYCursor();

        // Add distinctive colors for each column using adapter
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
      })

      // กำไรของสหกรณ์
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        // Themes end

        let chart = am4core.create("chartdiv4", am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect
        let data = [];
        let net = "หน่วย : ล้านบาท"
        for (let i = 0; i < res.length; i++) {
          if (res[i].netProfit) {
            data.push({
              "year": res[i].dataYear,
              "value": res[i].netProfit
            })
          }
        }

        chart.data = data;

        chart.logo.disabled = true;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();

        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        // valueAxis.min = 0;
        let series = chart.series.push(new am4charts.CurvedColumnSeries());
        series.dataFields.categoryX = "year";
        series.dataFields.valueY = "value";
        series.tooltipText = "{valueY.value}"
        series.columns.template.strokeOpacity = 0;


        series.columns.template.fillOpacity = 0.75;

        let hoverState = series.columns.template.states.create("hover");
        hoverState.properties.fillOpacity = 1;
        hoverState.properties.tension = 0.4;

        chart.cursor = new am4charts.XYCursor();

        // Add distinctive colors for each column using adapter
        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
      })
    })

    this.FamerServiceService.GetAgriBusinessFiveYears(this.coopId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // ปริมารธุรกิจ รับฝากเงิน
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_deposit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let depositVal1 = 0

        // Add data
        for (let i = 0; i < res.length; i++) {
          data.push({
            "year": res[i].yearData,
            "value": res[i].depositVal1
          })
          if (res[i].depositVal1) {
            depositVal1 += res[i].depositVal1;
            this.depositVal1Show = true;
          }
          if (depositVal1 == 0) {
            this.depositVal1Show = false;
          }

        }

        chart.data = data;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        title.disabled = false;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ ให้กู้
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_lend", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let creditVal1 = 0
        // Add data
        for (let i = 0; i < res.length; i++) {
          data.push({
            "year": res[i].yearData,
            "value": res[i].creditVal1
          })
          if (res[i].creditVal1) {
            creditVal1 += res[i].creditVal1;
            this.creditVal1Show = true;
          }
          if (creditVal1 == 0) {
            this.creditVal1Show = false;
          }

        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทให้กู้";
        title.disabled = false;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทให้กู้";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ จัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_products", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let saleVal1 = 0
        // Add data
        for (let i = 0; i < res.length; i++) {
          data.push({
            "year": res[i].yearData,
            "value": res[i].saleVal1
          })
          if (res[i].saleVal1) {
            saleVal1 += res[i].saleVal1;
            this.saleVal1Show = true;
          }
          if (saleVal1 == 0) {
            this.saleVal1Show = false;
          }


        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ รวบรวมผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_produce", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let collectVal1 = 0
        // Add data
        for (let i = 0; i < res.length; i++) {
          data.push({
            "year": res[i].yearData,
            "value": res[i].collectVal1
          })
          if (res[i].collectVal1) {
            collectVal1 += res[i].collectVal1;
            this.collectVal1Show = true;
          }
          if (collectVal1 == 0) {
            this.collectVal1Show = false;
          }

        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        title.disabled = false;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"


        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ แปรรูปผลผลิต
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_Processing", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let transformVal1 = 0
        // Add data
        for (let i = 0; i < res.length; i++) {
          data.push({
            "year": res[i].yearData,
            "value": res[i].transformVal1
          })
          if (res[i].transformVal1) {
            transformVal1 += res[i].transformVal1;
            this.transformVal1Show = true;
          }
          if (transformVal1 == 0) {
            this.transformVal1Show = false;
          }
        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        title.disabled = false;
        // Export
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // ปริมารธุรกิจ บรืการ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_business_service", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();
        let data = [];
        let net = "หน่วย : ล้านบาท"
        let serviceVal1 = 0
        // Add data
        for (let i = 0; i < res.length; i++) {
          data.push({
            "year": res[i].yearData,
            "value": res[i].serviceVal1
          })
          if (res[i].serviceVal1) {
            serviceVal1 += res[i].serviceVal1;
            this.serviceVal1Show = true;
          }
          if (serviceVal1 == 0) {
            this.serviceVal1Show = false;
          }

        }

        chart.data = data;
        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "ปริมาณธุรกิจ ประเภทบริการ";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "ปริมาณธุรกิจ ประเภทบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px"
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px"
        valueAxis.title.text = net
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        chart.logo.disabled = true;
        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

    })

    // การมีส่วนร่วมของสหกรณ์
    this.zone.runOutsideAngular(() => {
      this.FamerServiceService.GetAgriProfileBussinessFiveYears(this.coopId).subscribe(res => {
        res = callable.shiftYear(res, this.yearData);
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        // Add data
        let memberBusiness = 0
        for (let i = 0; i < res.length; i++) {

          if (res[i].memberBusiness) {
            this.year_Pratic = res[res.length - 1].dataYear;
            // memberBusiness += res[i].memberBusiness;
            // this.memberBusinessShow = true;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memberBusiness
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสหกรณ์";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสหกรณ์";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        categoryAxis.fontSize = "11px";
        //categoryAxis.title.text = "ปีชุดข้อมูล"

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px";
        valueAxis.title.text = "จำนวน (หน่วย : คน)"
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    this.FamerServiceService.GetAgriProfileBussinessFiveYears(this.coopId).subscribe(res => {
      res = callable.shiftYear(res, this.yearData);
      // การมีส่วนร่วม รับฝาก
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Deposit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        // Add data
        let memDeposit = 0;
        for (let i = 0; i < res.length; i++) {
          if (res[i].memDeposit) {
            this.year_Pratic_Deposit = res[res.length - 1].dataYear;
            memDeposit += res[i].memDeposit;
            this.memDepositShow = true;
          }
          if (memDeposit == 0) {
            this.memDepositShow = false;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memDeposit
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.fontSize = "11px";
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // การมีส่วนร่วม สินเชื่อ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Credit", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        // Add data
        let memCredit = 0

        for (let i = 0; i < res.length; i++) {
          if (res[i].memCredit) {
            this.year_Pratic_Credit = res[res.length - 1].dataYear;
            memCredit += res[i].memCredit;
            this.memCreditShow = true;

          }
          if (memCredit == 0) {
            this.memCreditShow = false;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memCredit
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสินเชื่อ";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสินเชื่อ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.fontSize = "11px";
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // การมีส่วนร่วม จัดหาสินค้ามาจำหน่าย
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Sale", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        let memSale = 0;
        // Add data

        for (let i = 0; i < res.length; i++) {
          if (res[i].memSale) {
            this.year_Pratic_Sale = res[res.length - 1].dataYear;

            memSale += res[i].memSale;
            this.memSaleShow = true;
          }
          if (memSale == 0) {
            this.memSaleShow = false;

          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memSale
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.fontSize = "11px";
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // การมีส่วนร่วม แปรรูป
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Good", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        let memGood = 0
        // Add data

        for (let i = 0; i < res.length; i++) {
          if (res[i].memGood) {
            this.year_Pratic_Good = res[res.length - 1].dataYear;

            memGood += res[i].memGood;
            this.memGoodShow = true;
          }
          if (memGood == 0) {
            this.memGoodShow = false;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memGood
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.fontSize = "11px";
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // การมีส่วนร่วม รวบรวม
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Mageting", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        let memMarketing = 0
        // Add data

        for (let i = 0; i < res.length; i++) {
          if (res[i].memMarketing) {
            this.year_Pratic_Mageting = res[res.length - 1].dataYear;
            memMarketing += res[i].memMarketing;
            this.memMarketingShow = true;

          }
          if (memMarketing == 0) {
            this.memMarketingShow = false;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memMarketing
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        // //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.fontSize = "11px";
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // การมีส่วนร่วม บริการ
      this.zone.runOutsideAngular(() => {

        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Service", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        let memService = 0
        // Add data

        for (let i = 0; i < res.length; i++) {
          if (res[i].memService) {
            this.year_Pratic_Service = res[res.length - 1].dataYear;

            memService += res[i].memService;
            this.memServiceShow = true;
          }
          if (memService == 0) {
            this.memServiceShow = false;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memService
            }
          )
        }


        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทธุรกิจบริการ";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทธุรกิจบริการ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.fontSize = "11px";
        valueAxis.min = 0;

        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })

      // การมีส่วนร่วม ธุรกิจอื่นๆ
      this.zone.runOutsideAngular(() => {
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartdiv_Pratic_Other", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        let data = [];
        let memOther = 0
        // Add data

        for (let i = 0; i < res.length; i++) {
          if (res[i].memOther) {
            this.year_Pratic_Other = res[res.length - 1].dataYear;

            memOther += res[i].memOther;
            this.memOtherShow = true;
          }
          if (memOther == 0) {
            this.memOtherShow = false;
          }
          data.push(
            {
              "year": res[i].dataYear,
              "value": res[i].memOther
            }
          )
        }

        chart.data = data;
        chart.logo.disabled = true;

        let title = chart.titles.create();
        title.fontSize = "11px";
        title.text = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทธุรกิจอื่น ๆ";
        title.disabled = false;

        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทธุรกิจอื่น ๆ";
        chart.exporting.useWebFonts = false;
        chart.exporting.validateSprites.push(title);
        chart.exporting.validateSprites.push(title.parent);

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 50;
        //categoryAxis.title.text = "ปีชุดข้อมูล"
        categoryAxis.fontSize = "11px";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.title.text = "จำนวน (หน่วย : คน)";
        valueAxis.fontSize = "11px";
        valueAxis.min = 0;
        // Create series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "year";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = -10;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#000')

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        let hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function (fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });

        // Cursor
        chart.cursor = new am4charts.XYCursor();
      })
    })

    // this.SpinnerService.hide();
  }

}
